// extracted by mini-css-extract-plugin
module.exports = {"noNewsContainer":"styles_noNewsContainer__1CBUD","newsPaperIcon":"styles_newsPaperIcon__2oESo","description":"styles_description__1b8T0"};